import Industry from "./industry";
import Finance from "../../../assets/finance.webp";
import Enterprise from "../../../assets/enterprise.webp";
import Commerce from "../../../assets/commerce.webp";
import Business from "../../../assets/business.webp";
import Health from "../../../assets/health.webp";
import Education from "../../../assets/education.webp";
import Human from "../../../assets/human.webp";
import SlideX from "../../atoms/slide-x";

const Industries = () => {
    return (
        <div className="industries-container">
            <div className="industries-inner">
                <div className="head">
                    <h4>Industries We Serve</h4>
                    <p>Our Solutions Cater to Diverse Industries, including Healthcare, Telecommunication, Education, Finance, and More allowing us Adapt Our Approach to Your Sector's Specific Demands and Opportunities.</p>
                </div>
                <div className="industries">
                <SlideX x_axis_start={-100}>
                    <Industry img={Finance} desc={"Finance"} />
                </SlideX>
                
                <SlideX x_axis_start={-100}>
                    <Industry img={Enterprise} desc={"Enterprise"} />
                </SlideX>
                
                <SlideX>
                    <Industry img={Commerce} desc={"Commerce"} />
                </SlideX>
                
                <SlideX>
                    <Industry img={Business} desc={"Business"} />
                </SlideX>
                
                <SlideX x_axis_start={-100}>
                    <Industry img={Health} desc={"Healthcare"} />
                </SlideX>
                
                <SlideX>
                    <Industry img={Education} desc={"Education"} />
                </SlideX>
                
                <SlideX>
                    <Industry img={Human} desc={"Human Resources"} />
                </SlideX>
            </div>
        </div>
    </div>
    )
}

export default Industries